export default "__VITE_ASSET__3a35bd41__"